<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  Unternehmen zuweisen

                  <v-spacer></v-spacer>
                  <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Suche"
                  single-line
                  hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                :headers="headers"
                :items="deviceList"
                :search="search"
                >
                  <template v-slot:item.name="{ item }">
                    <span class="handpointer" @click="select(item)">{{item.name}}</span>
                  </template>
                  <template v-slot:item.address="{ item }">
                    <span>{{item.street}}<br>{{item.postcode}} {{item.city}}</span>
                  </template>
                  <template v-slot:item.company="{ item }">
                    <span :style="getCompanyStyle(item)">
                      {{item.company}}
                      <span v-if="!item.company" class="handpointer" @click="openCompanyDialog(item)">zuweisen</span>
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-layout>

      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doSave()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DialogLinkCompany',
  components: {},
  methods: {
    /**
     * newName, title, type
     * @param cardConfig
     */
    doCancel: function () {
      this.dialog = false
      this.$emit('cancel', null)
    },
    doSave: function () {
      this.dialog = false
      this.$emit('save', {})
    },
    select: function (item) {
      console.log('onSelect', item)
      this.dialog = false
      this.$emit('save', item)
    },
    open: function (cardConfig) {
      if ((cardConfig != null) && (cardConfig)) {
        this.title = cardConfig.title
        this.description = cardConfig.description
      }
      this.reload()
      this.dialog = true
    },
    reload: function () {
      Vue.prototype.$apiCompany.loadCompanies(null, this.onGetData)
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Adresse', value: 'address'},
        /*{text: 'Strasse', value: 'street'},
        {text: 'PLZ', value: 'postcode'},
        {text: 'Stadt', value: 'city'},*/
        {text: 'E-Mail', value: 'email'},
        {text: 'Telefon', value: 'phonenumber'},
        {text: 'Aktion', value: 'action'}
        /*{text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ],
      search: '',
      deviceList: [],
      title: 'Login nicht erfolgreich',
      description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
      dialog: false
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
